import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import TagManager from 'react-gtm-module';
import './i18n';
import App from './Pages/App/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from './Store';
import { QueryClientContextProvider } from 'Context/QueryClientContext';

import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';
import '@fontsource/open-sans/300-italic.css';
import '@fontsource/open-sans/400-italic.css';
import '@fontsource/open-sans/600-italic.css';
import '@fontsource/open-sans/700-italic.css';
import '@fontsource/open-sans/800-italic.css';
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
import './Static/icomoon/style.css';
import 'react-resizable/css/styles.css';

const tagManagerArgs = {
  gtmId: `${process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY}`
};

TagManager.initialize(tagManagerArgs);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <QueryClientContextProvider>
    <Provider store={store}>
      <ToastContainer
        position="bottom-right"
        newestOnTop={false}
        style={{ maxHeight: 285, height: 'auto' }}
      />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </QueryClientContextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
